<template>
  <former-button
    :icon="icon"
    padded
    size="medium"
    :color="color || 'gray'"
    class="navigation-button"
    :href="href"
    :iconed="iconed"
    @click="click"
  >
    {{ label }}
  </former-button>
</template>

<script>
  import FormerButton from '@/components/Former/Button.vue';

  export default {
    name: 'NavigationButton',
    components: {
      FormerButton,
    },
    props: {
      label: {
        type: String,
        default: '',
      },
      icon: {
        type: String,
        default: '',
      },
      color: {
        type: String,
        default: '',
      },
      href: {
        type: [Object, String],
        default: '',
      },
      iconed: {
        type: Boolean,
        default: false,
      },
    },
    methods: {
      click() {
        this.$emit('click');
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@/assets/stylesheets/_variables.scss';

  .navigation-button {
  }
</style>
